import { Handle, Position } from "@xyflow/react";
import PiInputfield from "../../../components/PiInputField";
import { SWITCH_DEFAULT_HANDLE_ID } from "../../../models/interactions/Switch";
import useSwitchCaseNodePreview from "./useSwitchCaseNodePreview.hook";

export default function SwitchDefaultNodePreview(props: { nodeId: string }) {
  const { handleStyle } = useSwitchCaseNodePreview(
    props.nodeId,
    SWITCH_DEFAULT_HANDLE_ID
  );

  return (
    <div className="relative w-full">
      <div className="flex flex-col gap-[8px] noDrag nowheel">
        <div className="font-medium text-creator-text text-[14px]">Default</div>
        <div className="flex flex-row gap-2 items-center">
          <div className="flex-1 min-w-0">
            <PiInputfield
              label=""
              placeholder="Default"
              value=""
              onChange={() => {}}
              size="compact"
              disabled
            />
          </div>
        </div>
      </div>
      <Handle
        id={SWITCH_DEFAULT_HANDLE_ID}
        type="source"
        position={Position.Right}
        className="switch-case-handle"
        style={handleStyle}
      />
    </div>
  );
}
